import { render, staticRenderFns } from "./home-loan-amortization-table-new.vue?vue&type=template&id=958da8a4"
import script from "./home-loan-amortization-table-new.vue?vue&type=script&lang=js"
export * from "./home-loan-amortization-table-new.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/amortization-breakdown-table-new.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports